
export class Vistas {
    idRegistro?:number = 0;
    tipo?:string ="";
    tipoRegistro?:string ="";
    permisoExterno?:number=0;
    permisoTitular?:number= 0;
    vistaMiembros?:number=0;
    vistaProyectos?:number=0;
}
